export default {
  "region": "eu-west-2",
  "darwin_halo_host_name": "app.aidan-halo.sauce.construction",
  "darwin_user_pool_arn": "arn:aws:cognito-idp:eu-west-2:176647328773:userpool/eu-west-2_fQRx9eJP3",
  "darwin_user_pool_client_id": "lgjtkt0clasu9pkj1gcq7ao80",
  "darwin_user_pool_endpoint": "cognito-idp.eu-west-2.amazonaws.com/eu-west-2_fQRx9eJP3",
  "darwin_user_pool_id": "eu-west-2_fQRx9eJP3",
  "diagnostics_api_endpoint": "https://kx4kzlwhjf.execute-api.eu-west-2.amazonaws.com/dev",
  "halo_api_endpoint": "https://526pidczag.execute-api.eu-west-2.amazonaws.com/dev",
  "halo_websocket_api_endpoint": "wss://02dy8ee8jf.execute-api.eu-west-2.amazonaws.com/dev",
  "logic_iot_endpoint": "a1f7e9wxws15k4-ats.iot.eu-west-2.amazonaws.com",
  "sentry_env": "dev"
} // 10/30/2026, 1:04:46 PM